var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "InPlayerVideoOverlay",
    [
      _c(
        "OverlayContent",
        [
          _c("template", { slot: "message" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("player.download-overlay.mobile.header")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "DownloadAppButton",
            {
              attrs: {
                slot: "content",
                overlay: true,
                tracker: _vm.getAnalyticPayload(function(e) {
                  return e.player["overlay-download"].click.action
                }, _vm.video.id)
              },
              on: {
                click: function($event) {
                  return _vm.performAction({
                    tracker: {
                      label: "download-in-app"
                    }
                  })
                }
              },
              slot: "content"
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("player.download-overlay.mobile.install-cta")) +
                  "\n    "
              )
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "FooterAction",
        {
          attrs: {
            slot: "footer",
            tracker: _vm.getAnalyticPayload(function(e) {
              return e.player["overlay-download"].click.close
            }, _vm.video.id)
          },
          on: {
            click: function() {
              return _vm.dismiss({ autoplay: true })
            }
          },
          slot: "footer"
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("cancel")) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }